<div class="dashboard-container">
  <!-- Header -->
  <header class="dashboard-header">
    <div class="header-left">
      <h1>Design Request Dashboard</h1>
      <p class="header-subtitle">Track engineering design requests and performance metrics</p>
    </div>
    <div class="header-right">
      <div class="user-info">
        <span class="user-name">{{ currentUser.name }}</span>
        <span class="user-role">{{ currentUser.role }}</span>
      </div>
      <button kendoButton [themeColor]="'primary'" (click)="openNewRequest()">
        <span class="k-icon k-font-icon k-i-plus"></span>
        New Request
      </button>
    </div>
  </header>

  <!-- View Controls -->
  <section class="view-controls">
    <div class="view-controls-left">
      <span class="view-controls-title">View</span>
      <kendo-buttongroup>
        <button kendoButton [togglable]="true" [selected]="viewMode === 'minimal'" (click)="showMinimalView()">
          Minimal
        </button>
        <button kendoButton [togglable]="true" [selected]="viewMode === 'full'" (click)="showAllSections()">
          Full
        </button>
      </kendo-buttongroup>
    </div>
    <div class="view-controls-right">
      <div class="view-toggle">
        <kendo-switch [checked]="viewOptions.showScorecards" (valueChange)="toggleViewOption('showScorecards', $event)">
        </kendo-switch>
        <span>Scorecards</span>
      </div>
      <div class="view-toggle">
        <kendo-switch [checked]="viewOptions.showStatusOverview"
          (valueChange)="toggleViewOption('showStatusOverview', $event)">
        </kendo-switch>
        <span>Status cards</span>
      </div>
      <div class="view-toggle">
        <kendo-switch [checked]="viewOptions.showAnalytics" (valueChange)="toggleViewOption('showAnalytics', $event)">
        </kendo-switch>
        <span>Analytics</span>
      </div>
      <div class="view-toggle">
        <kendo-switch [checked]="viewOptions.showActionCenter"
          (valueChange)="toggleViewOption('showActionCenter', $event)">
        </kendo-switch>
        <span>Action center</span>
      </div>
      <div class="view-toggle">
        <kendo-switch [checked]="viewOptions.showFilters" (valueChange)="toggleViewOption('showFilters', $event)">
        </kendo-switch>
        <span>Filters</span>
      </div>
      <div class="view-toggle">
        <kendo-switch [checked]="viewOptions.showActivity" (valueChange)="toggleViewOption('showActivity', $event)">
        </kendo-switch>
        <span>Activity</span>
      </div>
    </div>
  </section>

  <!-- Scorecards Row -->
  <section class="scorecards" *ngIf="viewOptions.showScorecards">
    <div class="scorecard" *ngFor="let card of scorecards" [attr.data-color]="card.color">
      <div class="scorecard-icon">
        <span class="k-icon k-font-icon" [ngClass]="card.icon"></span>
      </div>
      <div class="scorecard-content">
        <span class="scorecard-value">{{ card.value }}</span>
        <span class="scorecard-label">{{ card.label }}</span>
      </div>
      <div class="scorecard-change" [class.positive]="card.change >= 0" [class.negative]="card.change < 0">
        <span class="k-icon k-font-icon" [ngClass]="card.change >= 0 ? 'k-i-arrow-up' : 'k-i-arrow-down'"></span>
        <span>{{ card.change > 0 ? '+' : '' }}{{ card.change }}%</span>
        <span class="change-label">{{ card.changeLabel }}</span>
      </div>
    </div>
  </section>

  <app-analytics *ngIf="viewOptions.showAnalytics" [timeRanges]="timeRanges" [selectedTimeRange]="selectedTimeRange"
    [chartCategories]="chartCategories" [userPerformanceData]="userPerformanceData"
    [teamPerformanceData]="teamPerformanceData" [statusChartData]="statusChartData"
    [avgTurnaroundDays]="avgTurnaroundDays" [isAdmin]="isAdmin" [groupAnalytics]="groupAnalytics"
    (timeRangeChange)="onTimeRangeChange($event)">
  </app-analytics>

  <!-- Action Center -->
  <section class="action-center" *ngIf="viewOptions.showActionCenter">
    <div class="panel review-queue-panel">
      <div class="panel-header">
        <h3>Review Queue</h3>
        <span class="results-count">{{ filteredReviewQueue.length }} awaiting review</span>
        <div class="panel-actions">
          <kendo-textbox [placeholder]="'Search reviews...'" [clearButton]="true" [(ngModel)]="reviewSearchTerm"
            (valueChange)="onReviewSearch($event)" class="review-search-box" [style.width.px]="200">
          </kendo-textbox>
          <button kendoButton (click)="toggleMyRequests(true)">
            Focus on my tasks
          </button>
        </div>
      </div>
      <div class="panel-body">
        <div class="review-list" *ngIf="filteredReviewQueue.length > 0; else reviewQueueEmpty"
             style="max-height: 750px; overflow-y: auto;">
          <div class="review-item" *ngFor="let review of filteredReviewQueue" [attr.data-priority]="review.priority">
            <div class="review-left">
              <div class="review-badge" [attr.data-priority]="review.priority">
                <span class="k-icon k-font-icon" [ngClass]="review.icon"></span>
              </div>
              <div class="review-info">
                <div class="review-title-row">
                  <button class="review-id" (click)="openReview(review)">#{{ review.id }}</button>
                  <span class="review-title" [innerHTML]="(review.title | slice:0:160) + (review.title?.length > 160 ? '...' : '')"></span>
                </div>
                <div class="review-meta">
                  <span class="review-chip review-chip-process" *ngIf="review.processName">{{ review.processName }}</span>
                  <span class="review-chip review-chip-type">{{ review.type }}</span>
                  <span class="review-chip review-chip-product">{{ review.productLine }}</span>
                  <span class="review-chip review-chip-requestor">Requested by {{ review.requestedBy }}</span>
                </div>
              </div>
            </div>
            <div class="review-right">
              <div class="review-due">
                <span class="due-label">Due</span>
                <span class="due-date" [class.overdue]="review.isOverdue">{{ review.dueDate | date:'MMM d' }}</span>
              </div>
              <div class="review-actions" *ngIf="review.isApproval">
                <button kendoButton [size]="'small'" [themeColor]="'success'" (click)="acceptReview(review)" [disabled]="isProcessingReview">
                  Approve
                </button>
                <button kendoButton [size]="'small'" [look]="'outline'" [themeColor]="'error'" (click)="declineReview(review)" [disabled]="isProcessingReview">
                  Reject
                </button>
              </div>
              <div class="review-actions" *ngIf="!review.isApproval">
                <button kendoButton [size]="'small'" [themeColor]="'info'" (click)="openReview(review)">
                  Open
                </button>
              </div>
            </div>
          </div>
        </div>
        <ng-template #reviewQueueEmpty>
          <div class="empty-state">
            <span class="k-icon k-font-icon k-i-check-circle"></span>
            <p>All caught up. No reviews waiting.</p>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Rejection Reason Dialog -->
    <kendo-dialog *ngIf="showRejectDialog" title="Reject Request" (close)="onCancelReject()" [width]="450">
      <p>Please provide a reason for rejecting this request:</p>
      <textarea kendoTextArea [(ngModel)]="rejectionReason" [rows]="4" style="width: 100%;" placeholder="Enter rejection reason..."></textarea>
      <kendo-dialog-actions>
        <button kendoButton (click)="onCancelReject()">Cancel</button>
        <button kendoButton [themeColor]="'error'" (click)="onConfirmReject()" [disabled]="!rejectionReason.trim() || isProcessingReview">
          Reject
        </button>
      </kendo-dialog-actions>
    </kendo-dialog>

    <div class="panel upcoming-panel">
      <div class="panel-header">
        <h3>Upcoming Deadlines</h3>
        <span class="results-count">{{ upcomingTasks.length }} tasks</span>
        <div class="panel-actions">
          <button kendoButton (click)="openUpcomingView()">
            View Calendar
          </button>
        </div>
      </div>
      <div class="panel-body">
        <div class="upcoming-list" *ngIf="upcomingTasks.length > 0; else upcomingEmpty"
             style="max-height: 750px; overflow-y: auto;">
          <div class="upcoming-item" *ngFor="let task of upcomingTasks" (click)="openUpcomingTask(task)">
            <div class="upcoming-left">
              <span class="upcoming-id">#{{ task.id }}</span>
              <p class="upcoming-title">{{ task.title }}</p>
              <div class="upcoming-meta">
                <span class="status-pill" [attr.data-status]="getStatusKey(task.status)">
                  {{ task.status }}
                </span>
                <span class="meta-chip">{{ task.assignee }}</span>
              </div>
            </div>
            <div class="upcoming-right">
              <span class="due-label">Due</span>
              <span class="due-date" [class.overdue]="task.isOverdue">{{ task.dueDate | date:'MMM d' }}</span>
              <span class="priority-chip" [attr.data-priority]="task.priority">{{ task.priority }}</span>
            </div>
          </div>
        </div>
        <ng-template #upcomingEmpty>
          <div class="empty-state">
            <span class="k-icon k-font-icon k-i-calendar"></span>
            <p>No upcoming deadlines in the next two weeks.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </section>

  <!-- Status Cards -->
  <section class="status-overview" *ngIf="viewOptions.showStatusOverview">
    <div class="status-card" *ngFor="let stat of statusCounts" [class.active]="activeStatusFilter === stat.status"
      [attr.data-status]="stat.statusKey" (click)="filterByStatus(stat.status)">
      <div class="status-card-inner">
        <div class="status-indicator"></div>
        <div class="status-content">
          <span class="status-count">{{ stat.count }}</span>
          <span class="status-label">{{ stat.status }}</span>
        </div>
      </div>
    </div>
  </section>

  <!-- Main Content -->
  <div class="main-content" [class.no-sidebar]="!viewOptions.showFilters && !viewOptions.showActivity">
    <!-- Left Sidebar - Filters -->
    <aside class="sidebar" *ngIf="viewOptions.showFilters || viewOptions.showActivity">
      <div class="panel" *ngIf="viewOptions.showFilters">
        <div class="panel-header">
          <h3>Filters</h3>
          <button kendoButton [look]="'flat'" [size]="'small'" *ngIf="hasActiveFilters()" (click)="clearFilters()">
            Clear
          </button>
        </div>
        <div class="panel-body">
          <form [formGroup]="filterForm" class="filter-form">
            <div class="filter-field">
              <label class="filter-label">Search</label>
              <kendo-textbox formControlName="search" placeholder="ID, description, bit type..." [clearButton]="true"
                (valueChange)="onFilterChange()">
              </kendo-textbox>
            </div>

            <div class="filter-field">
              <label class="filter-label">Status</label>
              <kendo-multiselect formControlName="status" [data]="statusOptions" placeholder="Any status"
                [clearButton]="true" (valueChange)="onFilterChange()">
              </kendo-multiselect>
            </div>

            <div class="filter-field">
              <label class="filter-label">Product Line</label>
              <kendo-multiselect formControlName="productLine" [data]="productLineOptions"
                placeholder="Any product line" [clearButton]="true" (valueChange)="onFilterChange()">
              </kendo-multiselect>
            </div>

            <div class="filter-field">
              <label class="filter-label">Type</label>
              <kendo-dropdownlist formControlName="type" [data]="typeOptions" [defaultItem]="'All Types'"
                [valuePrimitive]="true" (valueChange)="onFilterChange()">
              </kendo-dropdownlist>
            </div>

            <div class="filter-field">
              <label class="filter-label">Region</label>
              <kendo-dropdownlist formControlName="region" [data]="regionOptions" [defaultItem]="'All Regions'"
                [valuePrimitive]="true" (valueChange)="onFilterChange()">
              </kendo-dropdownlist>
            </div>

            <div class="filter-field">
              <label class="filter-label">Bit Series</label>
              <kendo-multiselect formControlName="bitSeries" [data]="bitSeriesOptions" placeholder="Any series"
                [clearButton]="true" (valueChange)="onFilterChange()">
              </kendo-multiselect>
            </div>

            <div class="filter-field">
              <label class="filter-label">Submitted Date</label>
              <div class="date-range-inputs">
                <kendo-datepicker formControlName="dateFrom" placeholder="From" (valueChange)="onFilterChange()">
                </kendo-datepicker>
                <kendo-datepicker formControlName="dateTo" placeholder="To" (valueChange)="onFilterChange()">
                </kendo-datepicker>
              </div>
            </div>

            <div class="filter-field">
              <label class="filter-label">Assigned To</label>
              <kendo-dropdownlist formControlName="assignedTo" [data]="assigneeOptions" [defaultItem]="'Anyone'"
                [valuePrimitive]="true" (valueChange)="onFilterChange()">
              </kendo-dropdownlist>
            </div>
          </form>
        </div>
      </div>

      <!-- My Recent Activity -->
      <div class="panel" *ngIf="viewOptions.showActivity">
        <div class="panel-header">
          <h3>My Recent Activity</h3>
        </div>
        <div class="panel-body">
          <div class="activity-list">
            <div class="activity-item" *ngFor="let activity of recentActivity">
              <div class="activity-icon" [attr.data-type]="activity.type">
                <span class="k-icon k-font-icon" [ngClass]="activity.icon"></span>
              </div>
              <div class="activity-content">
                <p class="activity-text">{{ activity.text }}</p>
                <span class="activity-time">{{ activity.time }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>

    <!-- Main Panel - Requests Grid -->
    <main class="content-area">
      <!-- eRTA / iRTA Toggle -->
      <div class="dashboard-tab-toggle">
        <kendo-buttongroup>
          <button kendoButton [togglable]="true" [selected]="dashboardTab === 'eRTA'" (click)="switchDashboardTab('eRTA')">
            eRTA Requests
          </button>
          <button kendoButton [togglable]="true" [selected]="dashboardTab === 'iRTA'" (click)="switchDashboardTab('iRTA')">
            iRTA Requests
          </button>
        </kendo-buttongroup>
      </div>

      <!-- eRTA Grid -->
      <div class="panel requests-panel" *ngIf="dashboardTab === 'eRTA'">
        <div class="panel-header">
          <h3>Design Requests</h3>
          <span class="results-count">{{ filteredRequests.length }} requests</span>
          <div class="panel-actions">
            <kendo-textbox [placeholder]="'Search requests...'" [clearButton]="true" [(ngModel)]="gridSearchTerm"
              (valueChange)="onGridSearch($event)" class="grid-search-box">
            </kendo-textbox>
            <kendo-buttongroup>
              <button kendoButton [togglable]="true" [selected]="showMyRequests"
                (selectedChange)="toggleMyRequests($event)">
                My Requests
              </button>
              <button kendoButton [togglable]="true" [selected]="!showMyRequests"
                (selectedChange)="toggleMyRequests(!$event)">
                All Requests
              </button>
            </kendo-buttongroup>
            <button kendoButton [togglable]="true" [selected]="showCompleted"
              (selectedChange)="toggleShowCompleted($event)" [icon]="'check-circle'">
              Show Completed
            </button>
            <button kendoButton (click)="exportData()">
              Export
            </button>
          </div>
        </div>
        <div class="panel-body no-padding">
          <kendo-grid [data]="gridData" [pageSize]="pageSize" [skip]="skip" [pageable]="{
                            buttonCount: 5,
                            info: true,
                            pageSizes: [10, 25, 50],
                            previousNext: true
                          }" [sortable]="true" [sort]="sort" [resizable]="false" [rowReorderable]="canReorderRows"
            [filterable]="'menu'" [filter]="gridFilter"
            (pageChange)="onPageChange($event)" (sortChange)="onSortChange($event)" (filterChange)="onGridFilterChange($event)" (rowReorder)="onRowReorder($event)"
            class="requests-grid">

            <kendo-grid-rowreorder-column *ngIf="canReorderRows" [width]="50">
              <ng-template kendoGridRowDragHintTemplate let-dataItem>
                <div class="hint-wrapper">
                  <kendo-svg-icon [icon]="dragIcon"></kendo-svg-icon>
                  <span>{{ dataItem.ID }}</span>
                  <div class="separator"></div>
                  <span>{{ dataItem.TypeName }}</span>
                  <div class="separator"></div>
                  <span>{{ dataItem.ProductLineName }}</span>
                  <div class="separator"></div>
                  <span>{{ dataItem.SeriesName }}</span>
                </div>
              </ng-template>
            </kendo-grid-rowreorder-column>

            <kendo-grid-column field="ID" title="ID" [width]="90" filter="numeric">
              <ng-template kendoGridCellTemplate let-dataItem>
                <a class="request-id"><span (click)="viewRequest(dataItem)">#{{ dataItem.ID }}</span></a>

                <!-- Priority text - clickable when user can reorder -->
                <span class="priority-text" [class.clickable]="canReorderRows"
                  [attr.data-priority]="getPriorityKey(dataItem.PriorityStatus)"
                  (click)="canReorderRows ? togglePriorityPopover(dataItem, $event) : null" #priorityAnchor>
                  {{ dataItem.PriorityStatus || 'Normal' }}
                </span>

                <!-- Priority Popover -->
                <kendo-popup *ngIf="isPriorityPopoverOpen(dataItem.ID)" [anchor]="priorityAnchor"
                  [anchorAlign]="{ horizontal: 'left', vertical: 'bottom' }"
                  [popupAlign]="{ horizontal: 'left', vertical: 'top' }" (anchorViewportLeave)="closePriorityPopover()">
                  <div class="priority-popover">
                    <div class="priority-popover-header">
                      <span>Set Priority</span>
                      <button class="priority-popover-close" (click)="closePriorityPopover()">×</button>
                    </div>
                    <div class="priority-popover-body">
                      <kendo-dropdownlist [data]="priorityOptions" textField="name" valueField="id"
                        [valuePrimitive]="true" [value]="dataItem.PriorityId"
                        (valueChange)="updatePriority(dataItem, $event)">
                      </kendo-dropdownlist>
                    </div>
                  </div>
                </kendo-popup>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="Description" title="Description" [width]="400">
              <ng-template kendoGridCellTemplate let-dataItem>
                <div class="description-cell">
                  <p class="description-text"
                    [innerHTML]="(dataItem.Description | slice:0:160) + (dataItem.Description?.length > 160 ? '...' : '')">
                  </p>
                  <div class="description-meta">
                    <span class="meta-tag" [ngStyle]="getMetaTagStyle(dataItem.TypeName)">{{ dataItem.TypeName }}</span>
                    <span class="meta-tag" [ngStyle]="getMetaTagStyle(dataItem.ProductLineName)">{{
                      dataItem.ProductLineName }}</span>
                    <span class="meta-tag" *ngIf="dataItem.SeriesName"
                      [ngStyle]="getMetaTagStyle(dataItem.SeriesName)">{{ dataItem.SeriesName }}</span>

                  </div>
                </div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="Size" title="Size" [width]="75" filter="numeric">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{ dataItem.Size || '-' }}</span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Type" title="Type" [width]="115">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{ dataItem.Type || '-' }}</span>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="Level" title="Lvl" [width]="75" filter="numeric">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{ dataItem.Level ?? '-' }}</span>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="ReferenceNumber" title="Ref #" [width]="115" filter="numeric">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{ dataItem.ReferenceNumber || '-' }}</span>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="MaterialNumber" title="Mat #" [width]="115" filter="numeric">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{ dataItem.MaterialNumber || '-' }}</span>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="ServicesNumber" title="Svc #" [width]="115" filter="numeric">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{ dataItem.ServicesNumber || '-' }}</span>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="IsComplete" title="Complete" [width]="100" filter="boolean">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span *ngIf="dataItem.IsComplete" class="k-icon k-font-icon k-i-check" style="color: green;"></span>
                <span *ngIf="!dataItem.IsComplete">Pending</span>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="TotalCostSavings" title="Savings" [width]="75" [filterable]="false">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span [ngClass]="{
                  'savings-positive': dataItem.TotalCostSavings != null && dataItem.TotalCostSavings > 0,
                  'savings-negative': dataItem.TotalCostSavings != null && dataItem.TotalCostSavings < 0
                }">{{ dataItem.TotalCostSavings != null ? (dataItem.TotalCostSavings | currency:'USD':'symbol':'1.0-0') : '-' }}</span>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="Status_Name" title="Status" [width]="250" [filterable]="false">
              <ng-template kendoGridCellTemplate let-dataItem>
                <div class="task-progress-container">
                  <!-- Task Progress Visualization -->
                  <ng-container *ngIf="dataItem.TaskData && parseTaskData(dataItem.TaskData).length > 0">
                    <div class="parent-tasks-row">
                      <div *ngFor="let parentTask of parseTaskData(dataItem.TaskData)" class="task-bar parent-task"
                        [ngClass]="getTaskStatusClass(parentTask.Status)"
                        [style.flex]="(parseChildTasks(parentTask.childTasks).length || 1) + ' 1 0%'"
                        [title]="'Parent Task ' + parentTask.Sequence + ': ' + getStatusAbbreviation(parentTask.Status) + (parentTask.Name ? ' - ' + parentTask.Name : '')">
                      </div>
                    </div>
                    <div class="child-tasks-row">
                      <ng-container *ngFor="let parentTask of parseTaskData(dataItem.TaskData)">
                        <div *ngFor="let childTask of parseChildTasks(parentTask.childTasks)"
                          class="task-bar child-task" [ngClass]="getTaskStatusClass(childTask.Status)"
                          [title]="'Child Task ' + childTask.Sequence + ': ' + getStatusAbbreviation(childTask.Status) + (childTask.Name ? ' - ' + childTask.Name : '')">
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="SubmittedBy" title="Submitted By" [width]="250">
              <ng-template kendoGridCellTemplate let-dataItem>
                <div><span style="font-weight: bold; font-size: large;">{{ dataItem.SubmittedBy }}</span><span *ngIf="dataItem.Region">{{' - ' + dataItem.Region}}</span></div>
                <small>{{ dataItem.DesignedBy_DisplayName}}</small>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="SubmittedDate" title="Submitted" [width]="110" [filterable]="false">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="date-cell">{{ dataItem.SubmittedDate | date:'MMM d, y' }}</span>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="RequiredDate" title="Required" [width]="110" [filterable]="false">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span class="date-cell" [class.overdue]="isOverdue(dataItem)">
                  {{ dataItem.RequiredDate | date:'MMM d, y' }}
                </span>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="" [width]="50" [sortable]="false" [filterable]="false"
        [sticky]="true">
              <ng-template kendoGridCellTemplate let-dataItem>
                <span *ngIf="canEditRequest(dataItem)" title="Edit Request">
                  <kendo-svg-icon [icon]="pencilIcon" style="color: red;"
                    (click)="editRequest(dataItem)"></kendo-svg-icon>
                </span>
              </ng-template>
            </kendo-grid-column>

            <ng-template kendoGridNoRecordsTemplate>
              <div class="no-records">
                <span class="k-icon k-font-icon k-i-search"></span>
                <p>No design requests found matching your criteria</p>
                <button kendoButton (click)="clearFilters()">Clear Filters</button>
              </div>
            </ng-template>
          </kendo-grid>
        </div>
      </div>

      <!-- iRTA Change List -->
      <div class="panel requests-panel" *ngIf="dashboardTab === 'iRTA'">
        <div class="panel-header">
          <h3>iRTA Change Orders</h3>
        </div>
        <div class="panel-body no-padding">
          <fv-change-list [showCreateButton]="true" [showActions]="true"
            (createClick)="selectRequestType('iRTA')"
            (actionClick)="onChangeListAction($event)">
          </fv-change-list>
        </div>
      </div>
    </main>
  </div>
</div>

<!-- New Request Modal -->
<kendo-dialog *ngIf="showNewRequestModal" [title]="'New Request'" [width]="500" (close)="closeNewRequestModal()">
  <div class="new-request-modal">
    <p class="modal-subtitle">Select the type of RTA request you want to create:</p>
    <div class="request-type-options">
      <div class="request-type-card" (click)="selectRequestType('eRTA')">
        <div class="request-type-icon erta-icon">
          <span class="k-icon k-font-icon k-i-file-add"></span>
        </div>
        <div class="request-type-content">
          <h4>eRTA</h4>
          <p>Engineering Request to Action - For external design requests</p>
        </div>
      </div>
      <div class="request-type-card" (click)="selectRequestType('iRTA')">
        <div class="request-type-icon irta-icon">
          <span class="k-icon k-font-icon k-i-file-wrench"></span>
        </div>
        <div class="request-type-content">
          <h4>iRTA</h4>
          <p>Internal Request to Action - For internal design requests</p>
        </div>
      </div>
    </div>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="closeNewRequestModal()">Cancel</button>
  </kendo-dialog-actions>
</kendo-dialog>